
<template>
  <div class="tabbar">
    <div class="left" @click="skip('1')">
      <img :src="tabKey == '1' ? '/static/images/qm.png' : '/static/images/qml.png'" alt="">
      <div>首页</div>
    </div>
    <div class="shu"></div>
    <div class="right" @click="skip('2')">
      <img :src="tabKey == '2' ? '/static/images/wd.png' : '/static/images/wdl.png'" alt="">
      <div>我的</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabbar',
  data() {
    return {
        tabKey: '1'
    }
  },
  props: {
    total: Number
  },
  mounted() {
    this.tabKey = sessionStorage.getItem("tabKey") || '1'
  },
  methods: {
    skip(val) {
      this.tabKey = val;
      sessionStorage.setItem("tabKey",val);
      // console.log(val)
      if (val == '1') {
        this.$router.push({ path: '/' });
      }else {
        this.$router.push({ path: '/mine' });
      }
      this.$emit('handleSizeChange',val)
    }
  }
}
</script>

<style lang="less" scoped>
.tabbar {
  width:750px;
  height:98px;
  background:rgba(255,255,255,1);
  box-shadow:0px -3px 13px 0px rgba(13,19,94,0.08);
  border-top: 1px solid rgba(223, 223, 223, 1);
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  .left {
    width: 49%;
    height: 100%;
    img {
      width: 47px;
      height: 48px;
      margin-top: 9px;
    }
  }
  .shu {
    width:2px;
    height:68px;
    background-color: rgba(223, 223, 223, 1);
  }
  .right {
    width: 49%;
    height: 100%;
    img {
      width: 52px;
      height: 49px;
      margin-top: 9px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar.vue